import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { User } from "../../schema/types/user/entity";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: customBaseQuery,
  tagTypes: ["User"],
  endpoints: (builder) => ({
    // TODO can be email or id, can always get the one and use that
    getUser: builder.query<User, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: link });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "User", id: link }],
    }),
  }),
});

export const { useGetUserQuery } = userApi;
